import { vm, socket } from "../socket/config.js";
import { sendMessageToServer } from "../socket/events.js";
import { targetToName, nameToTarget } from "../utils/scratch-helpers.js";
import {
    createModeModal,
    shouldSkipModal,
    showModeModal,
} from "../ui/modal.js";

import greenFlagGlobal from "../../../components/green-flag-global/green-flag-global.png";
import stopAllGlobal from "../../../components/stop-all-global/stop-global.png";

let localMode = false;
let localSpritesInfo = new Map(); // Map<name, JSON>
let localGlobalFlag = false;
let localStopAll = false;

export const isLocalMode = () => localMode;
export const getLocalSpritesInfo = () => localSpritesInfo;
export const isLocalGlobalFlag = () => localGlobalFlag;
export const setLocalGlobalFlag = (val) => {
    localGlobalFlag = val;
};
export const isLocalStopAll = () => localStopAll;
export const setLocalStopAll = (val) => {
    localStopAll = val;
};

export const getSpriteInfo = (target) => ({
    x: target.x,
    y: target.y,
    direction: target.direction,
    visible: target.visible,
    size: target.size,
});

export const applySpriteInfo = (target, info) => {
    target.x = info.x;
    target.y = info.y;
    target.direction = info.direction;
    target.visible = info.visible;
    target.size = info.size;

    if (target.renderer) {
        target.updateAllDrawableProperties();
    }
};

export const toggleLocalMode = () => {
    localMode = !localMode;
    return localMode;
};

export const executeModeChange = () => {
    const newMode = toggleLocalMode();
    sendMessageToServer("metric", {
        action: "mode_changed",
        newMode: newMode ? "Local" : "Global",
    });
    changeMode();

    if (newMode) {
        // Switching TO local mode
        if (localSpritesInfo.size === 0) {
            vm.runtime.targets.forEach((t) => {
                if (!t.isStage) {
                    const info = getSpriteInfo(t);
                    localSpritesInfo.set(targetToName(t), info);
                }
            });
            return;
        }

        localSpritesInfo.forEach((info, name) => {
            const target = vm.runtime.targets.find(
                (t) => !t.isStage && targetToName(t) === name,
            );
            if (target) applySpriteInfo(target, info);
        });
    } else {
        // Switching TO global mode
        vm.runtime.targets.forEach((t) => {
            if (!t.isStage) {
                const info = getSpriteInfo(t);
                localSpritesInfo.set(targetToName(t), info);
            }
        });
        window.socket.emit("retrieveSpritesInfo", {}, (data) => {
            if (localMode) return;
            for (let i = 0; i < data.info.length; i++) {
                const name = data.info[i].name;
                const target = nameToTarget(name);
                if (target) applySpriteInfo(target, data.info[i]);
            }
        });
    }
};

let btn, label, spriteInfo, greenFlag, stopAll, originalFlag, originalStop;

const changeMode = () => {
    spriteInfo.style.background = !localMode
        ? "rgba(255, 255, 255, 1)"
        : "#91bfff";
    btn.innerHTML = createModeIcon(localMode);
    btn.style.background = localMode ? "#4d97ff" : "#fff";
    btn.style.color = localMode ? "#fff" : "#4d97ff";
    label.textContent = localMode ? "Ejecutar para mi" : "Ejecutar para todos";
    label.style.color = localMode ? "#4d97ff" : "#575e75";
    label.style.borderColor = localMode
        ? "rgba(77,151,255,0.25)"
        : "rgba(0,0,0,0.08)";
    btn.title = localMode
        ? "Cambiar a ejecutar para todos"
        : "Cambiar a ejecutar para mí";
    greenFlag.src = localMode ? originalFlag : greenFlagGlobal;
    stopAll.src = localMode ? originalStop : stopAllGlobal;
};

export const setupLocalModeToggle = () => {
    spriteInfo = document.querySelector(".sprite-info_sprite-info_MA8v0");
    const headerInfo = document.querySelector(
        ".stage-header_stage-menu-wrapper_oLSb9",
    );
    const controlsContainer = document.querySelector(
        ".controls_controls-container_FKkXX",
    );
    greenFlag = document.querySelector(".green-flag_green-flag_eiU2I");
    stopAll = document.querySelector(".stop-all_stop-all_pluqe");

    if (!spriteInfo || document.querySelector(".custom-toggle-btn")) return;

    const modalOverlay = createModeModal();
    originalFlag = greenFlag.src;
    originalStop = stopAll.src;

    btn = document.createElement("button");
    btn.className = "custom-toggle-btn";
    btn.innerHTML = createModeIcon(localMode);
    btn.title = localMode
        ? "Cambiar a ejecutar para todos"
        : "Cambiar a ejecutar para mí";

    Object.assign(btn.style, {
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        border: "2px solid #4d97ff",
        background: localMode ? "#4d97ff" : "#fff",
        color: localMode ? "#fff" : "#4d97ff",
        fontSize: "14px",
        fontWeight: "bold",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "100",
        transition: "all 0.2s ease",
        padding: "0",
        lineHeight: "1",
        marginLeft: "8px",
    });

    label = document.createElement("div");
    label.id = "custom-mode-label";
    label.textContent = "Local Mode";

    Object.assign(label.style, {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: "13px",
        fontWeight: "600",
        color: "#575e75",
        background: "rgba(255,255,255,0.95)",
        padding: "3px 10px",
        borderRadius: "10px",
        border: "1px solid rgba(0,0,0,0.08)",
        pointerEvents: "none",
        zIndex: "99",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap",
        letterSpacing: "0.3px",
    });

    btn.addEventListener("click", (e) => {
        e.stopPropagation();

        if (!shouldSkipModal()) {
            showModeModal(modalOverlay, () => {
                executeModeChange();
            });
        } else executeModeChange();
    });

    if (getComputedStyle(spriteInfo).position === "static") {
        spriteInfo.style.position = "relative";
    }

    controlsContainer.appendChild(btn);
    headerInfo.appendChild(label);
    changeMode();
};

const createModeIcon = (isLocal) => {
    const personIcon = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="${isLocal ? "currentColor" : "none"}" 
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
            <circle cx="12" cy="7" r="4"></circle>
        </svg>
    `;

    const groupIcon = `
        <svg width="18" height="18" viewBox="0 0 24 24" fill="${!isLocal ? "currentColor" : "none"}" 
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
            <circle cx="9" cy="7" r="4"></circle>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
    `;

    return isLocal ? personIcon : groupIcon;
};
